import * as Constants from '../Constants';
export default {
    selectRoot(resources, response) {
        const location = response.xhr.headers.get(Constants.Headers.Location);
        if (response.xhr.status === 201 && location !== null) {
            return resources[response.resolveUri(location)] || null;
        }
        return null;
    },
};
//# sourceMappingURL=201LocationSelector.js.map